import {
  Grommet,
  Page,
  Button,
} from "grommet";
import React, { PropsWithChildren, useCallback, useEffect, useRef, useState } from "react";
import { AppBar } from "./app-bar";
import { Theme } from "../styles/theme";
import { AppFooter } from "./app-footer";
import { Up } from "grommet-icons";

// font color rgba(29, 142, 66, 1) (green)
// background rgba(34, 34, 34, 1) (black/grey)

// font color rgba(246, 232, 214, 1)
// background rgba(29, 142, 66, 1) (green)

// lighter green fill: rgb(125, 168, 99);
// lightest green: fill: rgb(191, 200, 155);

// font rgba(255, 102, 49, 1) (orange)


//font Bogam Weight 600 Normal

export const AppPage: React.FC<PropsWithChildren> = ({ children }) => {
  const [dark, setDark] = useState(false);

  const handleScroll = useCallback(() => {
    const button = document.getElementById("scrollToTop");

    if (button) {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        button.style.display = "block";
      } else {
        button.style.display = "none";
      }
    }
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]); 


  // When the user clicks on the button, scroll to the top of the document
  function topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  return (
    <Grommet theme={Theme} full themeMode={dark ? "dark" : "light"} style={{ height: "fit-content" }}>
      <Page style={{ height: "fit-content" }} >
        <AppBar setDark={setDark} dark={dark} />
        {children}
        <AppFooter />
        <Button id="scrollToTop" onClick={topFunction} style={{zIndex: 100}} icon={<Up />} title="Scroll to top"></Button>
      </Page>
    </Grommet>
  );
}